module.exports = __webpack_public_path__ + "media/images/new-capability-icon-c99ae5f2.png";